module.exports = __webpack_public_path__ + "public/images/bts_hero_image_4.4ce40b0a29328f407cb5a36420237b6f.webp";